<template>
  <layout-base id="gtr-emails-html">
    <!-- INTRO -->
    <layout-block margin="32px 0">
      <ui-logo :white="false" />
    </layout-block>
    <!-- TITLE -->
    <layout-block margin="32px 0">
      <layout-title :title="email.title" color="#06152F" />
    </layout-block>
    <!-- BODY -->
    <layout-block margin="32px 0" text-align="left">
      <div style="font-weight: 600;">
        {{ email.data.title }}
      </div>
      <div style="margin-top: 16px;" v-html="email.data.body"></div>
    </layout-block>
    <ui-button
      margin="32px 0"
      :label="email.data.cta.label"
      :href="email.data.cta.url"
      color="#ffffff"
      bg-color="#4e5cec"
    />
    <!-- ADDITIONAL INFO -->
    <layout-block margin="32px 0" text-align="left" v-if="email.data.footer" v-html="email.data.footer"></layout-block>
    <layout-block-separator />
    <!-- FOOTER -->
    <layout-block margin="32px 0 16px">
      <ui-logo :white="false" />
    </layout-block>
    <layout-block margin="16px 0">
      <internal-copyright />
    </layout-block>
    <layout-block margin="16px 0">
      <internal-social />
    </layout-block>
    <layout-block margin="16px 0 0">
      <ui-legend :label="$t('internal.footer')" font-size="10px" color="#53627c" margin="0" />
    </layout-block>
  </layout-base>
</template>

<script>
import LayoutBase from '@/components/Layout/Base.vue'
import LayoutBlock from '@/components/Layout/Block.vue'
import LayoutBlockSeparator from '@/components/Layout/Block/Separator.vue'
import LayoutTitle from '@/components/Layout/Title.vue'
import UiLogo from '@/components/UI/Logo.vue'
import UiButton from '@/components/UI/Button.vue'
import UiLegend from '@/components/UI/Legend.vue'
import InternalCopyright from '@/components/Internal/Copyright.vue'
import InternalSocial from '@/components/Internal/Social.vue'

export default {
  name: 'Internal',
  components: {
    LayoutBase,
    LayoutBlock,
    LayoutBlockSeparator,
    LayoutTitle,
    UiLogo,
    UiButton,
    UiLegend,
    InternalCopyright,
    InternalSocial,
  },
  created() {
    console.log(this.email)
  },
  props: {
    email: {
      type: Object,
      required: true,
    },
  },
}
</script>
